import f from "./ghl-ui.es1188.js";
import { createTheme as x } from "./ghl-ui.es855.js";
import H from "./ghl-ui.es1157.js";
import L from "./ghl-ui.es1164.js";
import z from "./ghl-ui.es1009.js";
const v = (i) => {
  const {
    borderRadius: r,
    popoverColor: n,
    textColor3: l,
    dividerColor: a,
    textColor2: e,
    primaryColorPressed: p,
    textColorDisabled: m,
    primaryColor: o,
    opacityDisabled: g,
    hoverColor: t,
    fontSizeSmall: c,
    fontSizeMedium: s,
    fontSizeLarge: C,
    fontSizeHuge: d,
    heightSmall: h,
    heightMedium: S,
    heightLarge: u,
    heightHuge: b
  } = i;
  return Object.assign(Object.assign({}, f), {
    optionFontSizeSmall: c,
    optionFontSizeMedium: s,
    optionFontSizeLarge: C,
    optionFontSizeHuge: d,
    optionHeightSmall: h,
    optionHeightMedium: S,
    optionHeightLarge: u,
    optionHeightHuge: b,
    borderRadius: r,
    color: n,
    groupHeaderTextColor: l,
    actionDividerColor: a,
    optionTextColor: e,
    optionTextColorPressed: p,
    optionTextColorDisabled: m,
    optionTextColorActive: o,
    optionOpacityDisabled: g,
    optionCheckColor: o,
    optionColorPending: t,
    optionColorActive: "rgba(0, 0, 0, 0)",
    optionColorActivePending: t,
    actionTextColor: e,
    loadingColor: o
  });
}, M = x({
  name: "InternalSelectMenu",
  common: H,
  peers: {
    Scrollbar: L,
    Empty: z
  },
  self: v
}), A = M;
export {
  A as default,
  v as self
};
